import React, { useMemo } from 'react';
import {
  Box, Button, Grid, Link, Typography,
} from '@mui/material';

export default function StepButtons({
  currentIndex, onBackClick, elements, currentElement,
}) {
  const isIframe = useMemo(() => window.self !== window.top, []);
  const isLastStep = currentIndex === (elements.length - 1) && currentElement.type !== 'switchForm';

  return (
    <Grid sx={{ pb: 2, pt: 6 }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: { xs: 'column-reverse', sm: 'row' },
          justifyContent: 'space-between',
          alignItems: 'stretch',
          gap: { xs: 1.5, sm: 0 },
        }}
      >
        {currentIndex !== 0 ? (
          <Button
            variant="outlined"
            onClick={onBackClick}
            sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
          >
            Zurück
          </Button>
        ) : <div />}
        <Button
          variant="contained"
          type="submit"
          sx={{ minWidth: { xs: '100%', sm: 'auto' } }}
        >
          {isLastStep ? 'Absenden' : 'Weiter'}
        </Button>
      </Box>
      {isIframe && (
        <Typography
          variant="caption"
          sx={{
            display: 'block', textAlign: 'center', color: 'lightgray', mt: 2,
          }}
        >
          Mit ❤️ von
          {' '}
          <Link href="https://wirkung-digital.de" target="_blank" sx={{ color: 'lightgray' }}>
            WIRKUNG digital
          </Link>
        </Typography>
      )}
    </Grid>
  );
}
